module.exports = __webpack_public_path__ + "static/media/kaylologo.04314fdd.svg";